<template>
    <div class="wrapper">
        <div id="certificate-item" class="certificate">
            <div class="certificate__wrapper">

                <h2 style="margin-top: 223px;" class="bold name">{{fullname}}</h2>
                <h2 style="margin-top: 223px;" class="bold name">{{title}}</h2>
                <p style="margin-top: 166px; margin-left:-530px;" class="bold name text-white">{{certificate_id}}</p>
                <p style="margin-top: 14px; margin-left:-580px;" class="bold name text-white">{{created_at.substr(0,10)}}</p>


            </div>
        </div>
        <br/>
        <button class="btn__grey" @click="print">Download/Print</button>
    </div>
</template>

<script>
  import domToImage from 'dom-to-image';
  import * as JsPdf from 'jspdf';

  export default {
    name: 'Certificate',
    props: {
      title: {
        type: String,
        default(){
          return '';
        }
      },
      created_at: {
        type: String,
        default(){
          return '';
        }
      },
      score: {
        type: Number,
        default(){
          return null;
        }
      }
    },
    data(){
      return {
        certificate_id:  this.$session.get('userData').certificate_id || "CLC-I-004732-2019-T",
        imgUrl: '',
        fname: this.$session.get('fname'),
        lname: this.$session.get('lname')
      };
    },
    computed: {
      fullname(){
        return `${this.fname} ${this.lname}`;
      }
    },
    mounted(){

    },
    methods: {
      print(){

        domToImage.toPng(document.getElementById('certificate-item'), {quality: 0.95})
          .then((dataUrl) => {
            this.imgUrl = dataUrl;
            const doc = new JsPdf('l', '', 'a4');
            doc.addImage(dataUrl, 'PNG', 0, 0, 297, 210);
            doc.save('certificate.pdf');
          })
          .catch((error) => {
            return error;
          });
        return true;
      }
    }
  };
</script>

<style lang="scss" scoped>
    @font-face {
        font-family: 'Oswald';
        font-style: normal;
        font-weight: 400;
        src: local('Oswald Regular'), local('Oswald-Regular'), url(https://fonts.gstatic.com/s/oswald/v11/_P8jt3Y65hJ9c4AzRE0V1OvvDin1pK8aKteLpeZ5c0A.woff2) format('woff2');
        unicode-range: U+0000-00FF, U+0131, U+0152-0153, U+02C6, U+02DA, U+02DC, U+2000-206F, U+2074, U+20AC, U+2212, U+2215, U+E0FF, U+EFFD, U+F000;
    }

    .wrapper {
        margin: 30px;
    }

    .certificate {
        width: 297mm;
        height: 210mm;
        overflow: visible;
        display: block;
        font-family: 'Oswald', sans-serif;
        border: 1px solid $grey-lightest;
        position: relative;
        margin-bottom: 5px;
        border-radius: 4px;
        overflow: hidden;
        background: $white;
        box-shadow: 4px 3px 83px 0px rgba(0, 0, 0, 0.13);

        &__img {
            margin-bottom: 30px;
            height: 50px;
        }
        &__wrapper {
            height: 210mm;
            margin-left: auto;
            padding: 20px 30px 30px;
            text-align: center;
            background-image: url('../assets/cpnCertificate2.png');
            background-size: 297mm 210mm;
        }
        &__header {
            padding-bottom: 30px;
        }
        &__meta {
            margin-top: 20px;
            font-style: italic;
            color: $grey;
            position: relative;
            padding-top: 15px;

        }
        &__body {
            padding-top: 50px;
            .bold {
                margin-top: 10px;
            }
        }
    }

    .name {
        text-transform: uppercase;
    }

    .meta {
        color: $grey-dark;
        font-weight: bold;
        padding-top: 20px;
    }

    button {
        height: 40px;
        margin-left: 0;
    }

</style>

